import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import BackLink from 'rebook/apps/base/components/BackLink';
import * as BookAuthorListActions from 'rebook/apps/books/actions/BookAuthorListActions';
import { Book } from 'rebook/apps/books/models';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class BookAuthorListView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    this.props.BookAuthorListActions.fetchInitialData(match, location);
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookAuthorListActions.fetchInitialData(match));
  }

  componentWillUnmount() {
    this.props.BookAuthorListActions.resetData();
  }

  render() {
    const { book } = this.props.bookAuthorList;
    const bookModel = new Book(book);

    return (
      <div className="backgroundContainer themeGrey">
        <div className="section col-md-6 col-lg-8">
          {book && (
            <div className={styles.breadCrumbs}>
              <BackLink link={bookModel.getLink()}>
                <span>{book.name}</span>
              </BackLink>
            </div>
          )}
          <div className="title-1">Все авторы книги</div>
          {book && (
            <small className={styles.authorsCount}>
              {book.authors.length} {pluralize(book.authors.length, 'автор', 'автора', 'авторов')}
            </small>
          )}
          {book && book.authors.map((author) => (
            <Link to={author.absolute_url} key={author.id}>
              <div className={classNames('billetContainer', styles.authorTemplate)}>
                <div className={styles.authorBlock}>
                  <CroppedImage
                    className={styles.authorImage}
                    height="40"
                    width="40"
                    src={author.photo} />
                  <div className={styles.authorInfo}>
                    <div className={styles.authorName}>{author.cover_name}</div>
                    <small className={styles.authorBookCount}>
                      {author.active_book_count} {pluralize(author.active_book_count, 'книга', 'книги', 'книг')}
                    </small>
                  </div>
                </div>
                <div className={styles.arrow} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    bookAuthorList: state.bookAuthorList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookAuthorListActions: bindActionCreators(BookAuthorListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookAuthorListView);
